import { render, staticRenderFns } from "./bonusDetails.vue?vue&type=template&id=75fe4f5b&scoped=true&"
import script from "./bonusDetails.vue?vue&type=script&lang=js&"
export * from "./bonusDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fe4f5b",
  null
  
)

export default component.exports